<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">文章管理 修改文章</div>
        </div>

        <div class="pg-block">
            <div class="pg-form-wrap">
                <Row>
                    <Col span="100" push="1">
                        <Form :label-width="50">
                            <Row :gutter="15">
                                <Col span="22">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>標題</span>
                                        </div>
										<Input v-model="form.title"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="22">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>正文</span>
                                        </div>
										<textarea v-model="form.content" hidden readonly></textarea>
										<div id="demo1"></div>
                                    </FormItem>
                                </Col>
                            </Row>
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style2" @click="handleCheckForm">修改</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
import wangEditor from 'wangeditor'

export default {
  data() {
    return {
	  pageParam: {},
	  form: {
	    title: '',
		content: '',
	  },
      editor: null,
      editorData: ''
    }
  },
  mounted() {
	this.pageParam = this.$route.query;
    const editor = new wangEditor(`#demo1`)
	editor.config.placeholder = '文章內容'
	editor.config.focus = true
    editor.config.onchange = (newHtml) => {
       this.form.content = newHtml
    }
    editor.create()
    this.editor = editor
	this.getDetail()
	
  },
  methods: {
	getDetail()
	{
	    this.$Rq.requestAuth({
	        url: this.$Api.articleDetail + '/' + this.pageParam.id,
	        method: 'get'
	    }).then((res) =>
	    {
	        if (res.code == 0)
	        {
	            let resData = res.data;
	            this.form = {
	                id: resData.id,
	                title: resData.title,
	                content: resData.content,
	                create_user: resData.create_user,
	                cid: resData.cid,
	                created_at: resData.created_at,
	                update_time: resData.update_time,
	            };
				this.editor.txt.html(this.form.content)
	        }
	    });
	},
	handleBack() {
		this.$router.go(-1);
	},
	handleCheckForm()
	{
	    let form = this.form;
	
	    if (form.title === '')
	    {
	        this.$Utils.showTipInfo('請輸入標題');
	        return;
	    } else if (form.content === '')
	    {
	        this.$Utils.showTipInfo('請輸入正文');
	        return;
	    }
	    this.handleSubmit();
	},
    handleSubmit()
    {
        let form = this.form;
        this.isSubmiting = true;
        this.$Rq.requestAuth({
            url: this.$Api.articleEdit + '/' + this.pageParam.id,
            method: 'post',
            data: {
                title: form.title,
                content: form.content,
            }
        }).then((res) =>
        {
            this.isSubmiting = false;
    
            if (res.code == 0)
            {
                this.$Utils.showSuccess(res.msg);
            } else
            {
                this.$Utils.showTipInfo(res.msg);
            }
        }).catch((err) =>
        {
            this.isSubmiting = false;
        });
    }
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy()
    this.editor = null
  }
}
</script>

<style lang="scss">
  @import "articleManageEdit.scss";
  .home {
    width: 1200px;
    margin: auto;
    position: relative;
    .btn {
      position: absolute;
      right: 0;
      top: 0;
      padding: 5px 10px;
      cursor: pointer;
    }
    h3 {
      margin: 30px 0 15px;
    }
  }
</style>
